export enum AlertNotificationStatus {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  SUPPRESSED = 'suppressed',
}
